import './bootstrap';
import { createInertiaApp } from '@inertiajs/vue3';
import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import Aura from '@primevue/themes/aura';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import axios from 'axios';
import { createI18n } from 'vue-i18n';
const appName = process.env.APP_NAME || 'Laravel';
// const cachedToken = localStorage.getItem('csrf_token');
//     if (cachedToken) {
//         axios.defaults.headers.common['X-CSRF-TOKEN'] = cachedToken;
//     }
window.addEventListener('message', (event) => {
    //   if (event.origin !== 'https://seite-a.de') return; TODO: check origin page (flaschenfreunde.de etc.)
    if (event.data.type === 'CSRF' && event.data.token) {
        // localStorage.setItem('csrf_token', event.data.token);
        axios.defaults.headers.common['X-CSRF-TOKEN'] = event.data.token;
        console.log('CSRF token set:', event.data.token);
    }
});
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./${name}.vue`),
    setup({ el, App, props, plugin }) {
        const locale = String(props.initialPage.props.locale) || "de";
        const messages = {
            [locale]: props.initialPage.props.translations,
        };
        const i18n = createI18n({
            legacy: false,
            locale: locale,
            fallbackLocale: "de",
            messages: messages,
            fallbackWarn: false,
            missingWarn: false,
        });
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n)
            .use(PrimeVue, {
            theme: {
                preset: Aura
            },
            locale: {
                accept: 'Ja, löschen',
                reject: 'Abbrechen',
                dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
                dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
                monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
                dateFormat: 'dd.mm.yy',
                clear: 'Löschen',
                today: 'Heute',
                aria: {
                    star: '1 Stern',
                    stars: '{star} Sterne',
                    pageLabel: 'Seite',
                    slideNumber: 'Slide'
                }
            }
        })
            .use(ConfirmationService)
            .use(ToastService)
            .directive('tooltip', Tooltip)
            .use(ZiggyVue)
            .mount(el);
    },
    progress: {
        // The delay after which the progress bar will appear, in milliseconds...
        // delay: 250,
        // The color of the progress bar...
        color: '#4B5563',
        // Whether to include the default NProgress styles...
        includeCSS: true,
        // Whether the NProgress spinner will be shown...
        showSpinner: false,
    },
});
// TinyMCE: Prevent Bootstrap dialog from blocking focusin
document.addEventListener('focusin', (e) => {
    if (e.target instanceof Element && e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root, .p-multiselect-filter, .p-dropdown-filter") !== null) {
        e.stopImmediatePropagation();
    }
});
